jQuery(document).ready(function($) {
    // Handler for .ready() called.

var $icon_slider = $('.icon-wrap')
var icon_slider_settings = {
  autoplay: true,
  autoplaySpeed: 4000,
  dots: false,
  infinite: true,
  slidesToShow: 1,
  prevArrow: '<button class="slick-arrow slick-prev"></button>',
  nextArrow: '<button class="slide-arrow slick-next"></button>',
  responsive: [
    {
      breakpoint: 99999,
      settings: "unslick"
    },{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      }
    }
  ]          
};

// Init Slider
$icon_slider.slick(icon_slider_settings);

// Reslick only if it's not slick()
$(window).on('resize', function() {
  if (!$icon_slider.hasClass('slick-initialized')) {
    return $icon_slider.slick(icon_slider_settings);
  }
});

  }); 

